import React from "react";
import { Paper, Box, Typography, IconButton } from "@mui/material";
import { Eye as EyeIcon, Pencil as PencilIcon, Trash as TrashIcon } from "lucide-react";

const SentenceItem = ({ sentence, onView, onEdit, onDelete }) => {
  return (
    <Paper
      elevation={1}
      sx={{
        p: 2,
        mb: 1,
        borderRadius: 2,
        transition: "all 0.2s",
        "&:hover": { boxShadow: 3 }
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography variant="subtitle1" fontWeight="medium">
          {sentence.text}
        </Typography>
        <Box sx={{ display: "flex" }}>
          <IconButton size="small" color="primary" onClick={() => onView && onView(sentence)} title="View Sentence">
            <EyeIcon size={16} />
          </IconButton>
          <IconButton size="small" color="primary" onClick={() => onEdit && onEdit(sentence)} title="Edit Sentence">
            <PencilIcon size={16} />
          </IconButton>
          <IconButton size="small" color="error" onClick={() => onDelete && onDelete(sentence)} title="Delete Sentence">
            <TrashIcon size={16} />
          </IconButton>
        </Box>
      </Box>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
        {sentence.translation}
      </Typography>
    </Paper>
  );
};

export default SentenceItem;
